import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.864 4.247A7.5 7.5 0 0 1 19.5 10.504c0 2.92-.556 5.71-1.568 8.27M5.742 6.368A7.47 7.47 0 0 0 4.5 10.505a7.47 7.47 0 0 1-1.15 3.993m1.989 3.559a11.2 11.2 0 0 0 2.911-7.552 3.75 3.75 0 0 1 7.5 0q0 .79-.064 1.564M12 10.505c0 3.722-1.356 7.128-3.6 9.75m6.633-4.596a18.7 18.7 0 0 1-2.485 5.33"
    }, null, -1)
  ])))
}
export default { render: render }